// extracted by mini-css-extract-plugin
export default {"row":"styles_row__A-hkk","header":"styles_header__PsGef","not_header":"styles_not_header__93WF0","delete":"styles_delete__p4xbP"};